import i18n from '@src/i18n'
const t = i18n?.global.t
const FEATURES_NAME = {
  CLASSES: [
    { title: 'grades', name: 'GRADES' },
    { title: 'levels', name: 'LEVELS' },
    { title: 'courses', name: 'COURSES' },
    { title: 'standards', name: 'STANDARDS' },
    { title: 'departments', name: 'DEPARTMENTS' },
    { title: 'classes', name: 'CLASSES' },
  ],
  SECTION: [
    { title: 'groups', name: 'GROUPS' },
    { title: 'divisions', name: 'DIVISIONS' },
    { title: 'streams', name: 'STREAMS' },
    { title: 'cohorts', name: 'COHORTS' },
    { title: 'units', name: 'UNITS' },
    { title: 'teams', name: 'TEAMS' },
    { title: 'sections', name: 'SECTIONS' },
  ],
  CAMPUS_ATTENDANCE: [
    { title: 'institute attendance', name: 'INSTITUTE_ATTENDANCE' },
    { title: 'school attendance', name: 'SCHOOL_ATTENDANCE' },
    { title: 'branch attendance', name: 'BRANCH_ATTENDANCE' },
    { title: 'organization attendance', name: 'ORGANIZATION_ATTENDANCE' },
    { title: 'master attendance', name: 'MASTER_ATTENDANCE' },
    { title: 'campus attendance', name: 'CAMPUS_ATTENDANCE' },
  ],
  PERIOD_ATTENDANCE: [
    { title: 'subject attendance', name: 'SUBJECT_ATTENDANCE' },
    { title: 'time slot attendance', name: 'TIME_SLOT_ATTENDANCE' },
    { title: 'hourly attendance', name: 'HOURLY_ATTENDANCE' },
    { title: 'session attendance', name: 'SESSION_ATTENDANCE' },
    { title: 'lecture attendance', name: 'LECTURE_ATTENDANCE' },
    { title: 'class hour attendance', name: 'CLASS_HOUR_ATTENDANCE' },
    { title: 'period attendance', name: 'PERIOD_ATTENDANCE' },
  ],
  SECTION_ATTENDANCE: [
    { title: 'group attendance', name: 'GROUP_ATTENDANCE' },
    { title: 'stream attendance', name: 'STREAM_ATTENDANCE' },
    { title: 'sub-class attendance', name: 'SUB-CLASS_ATTENDANCE' },
    { title: 'unit attendance', name: 'UNIT_ATTENDANCE' },
    { title: 'division attendance', name: 'DIVISION_ATTENDANCE' },
    { title: 'section attendance', name: 'SECTION_ATTENDANCE' },
  ],
}

export const MYQAMPUS_FEATURE_NAMES = {
  // Students Attendance Features
  STUDENTS_CAMPUS_ATTENDANCE: 'FEATURE_CAMPUS_ATTENDANCE',
  STUDENTS_SECTION_ATTENDANCE: 'FEATURE_SECTION_ATTENDANCE',
  STUDENTS_PERIOD_ATTENDANCE: 'FEATURE_PERIOD_ATTENDANCE',
  STUDENTS_DAILY_ATTENDANCE: 'FEATURE_DAILY_ATTENDANCE',
  // Staff Attendance Features
  STAFF_CAMPUS_ATTENDANCE: 'FEATURE_STAFF_CAMPUS_ATTENDANCE',
  STAFF_DAILY_ATTENDANCE: 'FEATURE_STAFF_DAILY_ATTENDANCE',
  // Other Features
  TIME_TABLE_MANAGER: 'FEATURE_TIMETABLE_MANAGER',
  SYLLABUS_AUTOMATER: 'FEATURE_SYLLABUS_AUTOMATOR',
  SYLLABUS_MANAGER: 'FEATURE_SYLLABUS_MANAGER',
  ASSIGNMENT: 'FEATURE_ASSIGNMENT',
  FEE_MANAGER: 'FEATURE_FEE_MANAGER',
  PICKUP_MANAGER: 'FEATURE_PICKUP_MANAGER',
  ANNOUNCEMENTS: 'FEATURE_ANNOUNCEMENT',
  SUPPORT_QUERY: 'FEATURE_SUPPORT_QUERY',
  EXAMS_MANAGER: 'FEATURE_EXAMS_MANAGER',
  LESSON_PLANNER: 'FEATURE_LESSON_PLANNER',
  EXAMS_MANAGER: 'FEATURE_EXAMS_MANAGER',
  PICKUP_MANAGER: 'FEATURE_PICKUP_MANAGER',
  TIMETABLE_MANAGER: 'FEATURE_TIMETABLE_MANAGER',
  GRADES_MANAGER: 'FEATURE_GRADES_MANAGER',
}

export default FEATURES_NAME
